//MUI
import styled from "@emotion/styled";
import Typography from "@mui/material/Typography";

const ServiceContainer = styled("div")(({ theme }) => ({
  width: "300px",
  height: "232px",
  padding: "1rem",
  boxShadow: "2px 2px 9px 0px #00000017",
  border: "1px solid #ECF0FC",
  borderRadius: "15px",
  cursor: "pointer",
  transition: "transform 0.3s ease, box-shadow 0.3s ease, border 0.3s ease",
  "& .headers": {
    width: "100%",
    height: "80px",
    "& .heading": {
      width: "100%",
      display: "flex",
      alignItems: "center",
      gap: "0.5rem",
      "& .img_block": {
        width: "11%",
        background: "#ECF0FC",
        padding: "0.3rem",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        "& .img_style": {
          width: "100%",
          height: "20px",
        },
      },
      "& .heading_text": {
        width: "89%",
        textTransform: "uppercase",
        color: "#1B1C1E",
        fontWeight: "600",
        fontSize: "15px",
      },
    },
    "& .description": {
      width: "100%",
      display: "flex",
      alignItems: "center",
      gap: "0.5rem",
      "& .empty_block": {
        width: "11%",
      },
      "& .description_text": {
        width: "89%",
        color: "#4F4F4F",
        fontSize: "12px",
        fontWeight: "400",
      },
    }
  },
  "& .img_container": {
    width: "100%",
    height: "120px",
    "& .service_img": {
      width: "100%",
      height: "120px",
      borderRadius: "8px",
    },
  },
  "&:hover": {
    boxShadow: "0px 2px 9px 0px #23B1EC40",
    border: "1px solid #00A0E3",
    transform: "scale(1.1)",
  },
}));

const ServiceCardAI = ({ data, handleSection }) => {
  return (
    <ServiceContainer
      onClick={() => handleSection(data?.path)}
    >
      <div className="headers">
        <div className="heading">
          <div className="img_block">
            <img
              src={data?.serviceHeadImg}
              alt={data?.name}
              className="img_style"
            />
          </div>
          <Typography className="heading_text">{data?.name}</Typography>
        </div>
        <div className="description">
          <div className="empty_block">

          </div>
          <Typography className="description_text">{data?.desc}</Typography>
        </div>
      </div>
      <div className="img_container">
        <img 
          src={data?.serviceImg}
          alt={data?.name}
          className="service_img"
        />
      </div>
    </ServiceContainer>
  );
};

export default ServiceCardAI;